import type { ReactNode } from "react";
import {
  Box,
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  TextField,
  InputAdornment,
} from "@mui/material";
import { Search, Plus } from "lucide-react";

interface InspectionOrdersListShellProps {
  children: ReactNode;
}

export default function InspectionOrdersListShell({ children }: InspectionOrdersListShellProps) {
  return (
    <Box>
      <Box sx={{ display: "flex", flexWrap: "wrap", alignItems: "center", gap: 2, mb: 2 }}>
        <TextField
          placeholder="Search by inspection order name..."
          variant="outlined"
          size="small"
          disabled
          sx={{ minWidth: 280 }}
          InputProps={{
            startAdornment: (
              <InputAdornment position="start">
                <Search size={18} />
              </InputAdornment>
            ),
          }}
        />
        <FormControl size="small" sx={{ minWidth: 200 }} disabled>
          <InputLabel id="status-filter-label">Inspection Order Status</InputLabel>
          <Select labelId="status-filter-label" value="" label="Inspection Order Status">
            <MenuItem value="">All</MenuItem>
          </Select>
        </FormControl>
        <Button
          variant="contained"
          startIcon={<Plus size={18} />}
          disabled
          sx={{ borderRadius: "8px", textTransform: "none", ml: "auto" }}
        >
          Create Inspection Order
        </Button>
      </Box>
      {children}
    </Box>
  );
}
